<template>
  <div :class="[data.class, 'nested-group']">
    <component
        :is="'APPROVAL_' + field.fieldType"
        v-for="(field, fieldKey) in data.fields"
        :key="fieldKey"
        :data="field"
        :footnotes="footnotes"
    ></component>
  </div>
</template>

<script>

import APPROVAL_CHECKBOX
  from "./CHECKBOX.vue"
import APPROVAL_TEXT
  from "./TEXT.vue"
import APPROVAL_TEXTAREA
  from "./TEXTAREA.vue"
import APPROVAL_INPUT
  from "./INPUT.vue"
import APPROVAL_TABLE
  from "./TABLE.vue"
import APPROVAL_NESTED_GROUP
  from "./NESTED_GROUP.vue"
import DocumentContainer
  from "../../document/DocumentContainer.vue"
import TableShortlistProducts
  from "../../table/TableShortlistProducts.vue"

export default {
  name: 'NESTED_GROUP',
  props: ['data', 'footnotes'],


  components: {
    DocumentContainer,
    TableShortlistProducts,
    APPROVAL_CHECKBOX,
    APPROVAL_TEXT,
    APPROVAL_TEXTAREA,
    APPROVAL_INPUT,
    APPROVAL_TABLE,
    APPROVAL_NESTED_GROUP,
  },
}
</script>



// WEBPACK FOOTER //
// NESTED_GROUP.vue?0e814ba6